<form-control
  [group]="group"
  [config]="dropdownConfig"
  [control]="group.get(config.prop)"
  data-test-id="dropdownOtherSelectControl"
>
</form-control>

@if (otherControl) {
  <form-control
    [group]="group"
    [config]="otherTextConfig"
    [control]="otherControl"
    data-test-id="dropdownOtherTextInput"
  >
  </form-control>
}
